/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=1505a058"
const script = {}

import exportComponent from "D:\\fe\\vgo-fe\\vgo-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__